export default __webpack_public_path__ + "static/media/Calendar.b03a6969.png";